(()=>{'use strict';
const trigger=document.getElementById('menu-toggle'),menu=document.getElementById('site-menu');
if(!trigger||!menu)return;
const main=menu.querySelector('#menu-main'),support=menu.querySelector('#menu-support'),openSupport=menu.querySelector('.menu-support-open'),back=menu.querySelector('.menu-back');
function reset(){main.hidden=false;support.hidden=true;openSupport.setAttribute('aria-expanded','false')}
trigger.addEventListener('click',()=>{reset();menu.showModal();trigger.setAttribute('aria-expanded','true');trigger.setAttribute('aria-label','Menüyü kapat')});
menu.querySelector('.menu-close').addEventListener('click',()=>menu.close());
menu.addEventListener('click',event=>{if(event.target===menu)menu.close()});
menu.addEventListener('close',()=>{trigger.setAttribute('aria-expanded','false');trigger.setAttribute('aria-label','Menüyü aç');reset();trigger.focus()});
openSupport.addEventListener('click',()=>{main.hidden=true;support.hidden=false;openSupport.setAttribute('aria-expanded','true');back.focus()});
back.addEventListener('click',()=>{reset();openSupport.focus()});
if(document.getElementById('info-dialog')){
  const url=new URL(location.href),request=url.searchParams.get('menu');
  if(request==='tracking'||request==='contact'){
    url.searchParams.delete('menu');history.replaceState(null,'',url.pathname+url.search+url.hash);
    requestAnimationFrame(()=>document.querySelector(request==='tracking'?'[data-policy="tracking"]':'[data-info="contact"]')?.click());
  }
  const openShippingFromHash=()=>{
    if(location.hash!=='#shipping-details')return;
    const details=document.getElementById('shipping-details');details.open=true;
    requestAnimationFrame(()=>details.scrollIntoView({block:'start'}));
  };
  openShippingFromHash();
  addEventListener('hashchange',openShippingFromHash);
}
})();
